<template>
  <div class="home">
    <div class="content-box">
      <div class="title">中国食品工业协会MA全国食品注册服务平台</div>
      <div class="english-title">China National Food Industry Association MA National Food Registration Service Platform</div>
      <div class="btn-group">
        <el-button class="btn-apply" @click="handleApply">申请加入</el-button>
        <el-button class="btn-login" @click="handleLogin">用户登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  methods: {
    handleLogin() {
      window.open('http://www.mafood.cn/front/#/login', '_self');
    },
    handleApply() {
      window.open('http://www.mafood.cn/front/#/SignUp', '_self');
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: url(../../assets/images/bj.jpg) no-repeat center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;

  .content-box {
    text-align: center;

    .title {
      font-family: PangMenZhengDao, PangMenZhengDao;
      font-weight: 600;
      font-size: 41px;
      color: #006300;
      letter-spacing: 2px;
      margin-bottom: 11px;
    }

    .english-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 15px;
      color: #006300;
      letter-spacing: 1px;
      margin-bottom: 11px;
    }

    .btn-group {
      margin-top: 53px;

      .el-button {
        width: 139px;
        height: 44px;
        border-radius: 6px;
        border: none;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
      }

      .btn-apply {
        background: #ec3d0e;
        color: #ffffff;
        margin-right: 54px;
      }

      .btn-login {
        background: #ffffff;
        color: #006300;
      }
    }
  }
}
</style>
